const TabPanel = ({ children, value, index, ...otherProps }) => {
  return (
    <div role="tabpanel" hidden={value !== index} {...otherProps}>
      {value === index && children}
    </div>
  );
};

export default TabPanel;
